import { type Opportunity, deleteOrderInfo } from "@repo/api";
import { t } from "@repo/translation";
import { type Toast } from "@repo/utils";
import { getErrorMessage } from "@repo/utils";

import { setActiveProject } from "../project/setActiveProject";

export const onDeleteOrder = ({
  opportunityId,
  orderId,
  updateToast,
}: {
  opportunityId?: number;
  orderId: string;
  updateToast: (toast: Toast) => void;
}) =>
  deleteOrderInfo(opportunityId, orderId)
    .then(() => {
      updateToast({
        id: orderId,
        title: t("prompt.draft_order_removed"),
      });
    })
    .catch((e) => {
      updateToast({
        id: orderId,
        title: t("prompt.failed_to_remove_draft_order"),
        message: getErrorMessage(e),
        type: "error",
      });
    });

export const getAllOrdersIds = (opportunity?: Opportunity) =>
  opportunity?.orders?.allOrders?.map((order) => order.orderId) ?? [];

export const handleCreateOrder = (
  opportunity: Opportunity,
  market: string,
  language: string
) => {
  setActiveProject(opportunity);

  const baseUrl = import.meta.env.VITE__WEB_SALJA_V2;
  return window.open(`${baseUrl}/${market}/${language}/v1/cart/`, "_blank");
};
